import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["video", "overlay"]

  connect() {
    if (this.hasVideoTarget && this.hasOverlayTarget) {
      this.setupEventListeners()
    }
  }

  disconnect() {
    if (this.hasVideoTarget && this.hasOverlayTarget) {
      this.removeEventListeners()
    }
  }

  setupEventListeners() {
    this.overlayTarget.addEventListener('click', this.playVideo.bind(this))
    this.videoTarget.addEventListener('play', this.hideOverlay.bind(this))
  }

  removeEventListeners() {
    this.overlayTarget.removeEventListener('click', this.playVideo.bind(this))
    this.videoTarget.removeEventListener('play', this.hideOverlay.bind(this))
  }

  playVideo() {
    this.videoTarget.play()
    this.hideOverlay()
  }

  hideOverlay() {
    this.overlayTarget.style.display = 'none'
  }
}

